"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _element = require("@wordpress/element");

var _components = require("@wordpress/components");

var _draggableChip = _interopRequireDefault(require("../block-draggable/draggable-chip"));

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
var InserterDraggableBlocks = function InserterDraggableBlocks(_ref) {
  var isEnabled = _ref.isEnabled,
      blocks = _ref.blocks,
      icon = _ref.icon,
      children = _ref.children;
  var transferData = {
    type: 'inserter',
    blocks: blocks
  };
  return (0, _element.createElement)(_components.Draggable, {
    transferData: transferData,
    __experimentalDragComponent: (0, _element.createElement)(_draggableChip.default, {
      count: blocks.length,
      icon: icon
    })
  }, function (_ref2) {
    var onDraggableStart = _ref2.onDraggableStart,
        onDraggableEnd = _ref2.onDraggableEnd;
    return children({
      draggable: isEnabled,
      onDragStart: isEnabled ? onDraggableStart : undefined,
      onDragEnd: isEnabled ? onDraggableEnd : undefined
    });
  });
};

var _default = InserterDraggableBlocks;
exports.default = _default;
//# sourceMappingURL=index.js.map